import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { DEVICE_TEMPERATURE_GRAPH } from './url-constants';

type TemperatureGraphEndpointSpecification = ApiEndpointSpecification;
export const TemperatureGraphEndpointSpecification: TemperatureGraphEndpointSpecification = {
    url: DEVICE_TEMPERATURE_GRAPH,
    method: HttpMethod.POST,
    requestParamsSchemaName: 'TemperatureGraphRequestParams',
    requestBodySchemaName: 'TemperatureGraphRequestBody',
    okResponseSchemaName: 'TemperatureGraphOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
    version:2
};

export const invokeTemperatureGraphData = Helpers.makeApiRequestFn<
    Types.TemperatureGraphRequestParams,
    Types.TemperatureGraphRequestBody,
    Types.TemperatureGraphOkResponse
>(TemperatureGraphEndpointSpecification);
